import packageInfo from '../../package.json';

const config = {
    databaseName: 'zorgbord',
    apiUrl: process.env.API_URL,
    paymentUrl: process.env.PAYMENT_URL,
    apiClientID: process.env.CLIENT_ID,
    apiClientSecret: process.env.CLIENT_SECRET,
    appVersion: packageInfo.version,
    translated: true,
    sortedTimes: [
        100,
        22,
        38,
        44,
        49,
        60,
    ],
    sortedTimes20: [ 
        100,
        20,
    ]
};

export default config;



// WEBPACK FOOTER //
// ./src/lib/config.js